<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <filterByStatus
            pageTitle="Theo dõi văn bản trình ký"
          />
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <div class="list-docs wrapper-content__main">
          <subHeader>
            <template #content>
              <div class="leftSection">
                <el-button size="medium"
                           type="success"
                           class="createNew"
                           v-if="flowId !== null"
                           @click="isOpenDialogCreate = true, isEnableDialogCreate = true">
                  <div class="flex-row flex__center">
                    <i class="fas fa-plus-circle font-size__large"></i>
                    <span>&nbsp;&nbsp;THÊM MỚI</span>
                  </div>
                </el-button>
              </div>

              <searchTemplate
                :keyword="searchKey"
                @simpleSearch="search"
                @search="openAdvanceSearchDialog"
              >
                <template #advance>
                  <advanceSearchDialog
                    :isOpen="isOpenAdvanceSearchDialog"
                    :hcFlow="hcFlow"
                    v-if="isEnableAdvanceSearchDialog"
                    @dialogClosed="isEnableAdvanceSearchDialog = false"
                    @closeDialog="isOpenAdvanceSearchDialog = false"
                    @doSearch="advanceSearch"
                    @exportExcel="exportExcel"
                  />
                </template>
              </searchTemplate>


            </template>
          </subHeader>

          <mainContent
            ref="mainContent1"
            @viewDetail="viewDetail"
            @viewDetailSteps="viewDetailSteps"
            @viewDetailHistory="viewDetailHistory"
            @viewDetailReturn="viewDetailReturn"
            @nhanVanBan="nhanVanBan"
            @donViNhanVanBan="donViNhanVanBan"
            @donViBaoCao="donViBaoCao"
            @huyVanBan="huyVanBan"
            @infiniteHandler="infiniteHandler"
            :hcFlow="hcFlow"
            :data="hcCaseDocs">
          </mainContent>

          <registerLuongVbDialog
            :isOpen="isOpenDialogCreate"
            :flowId="flowId"
            :flowCode="flowCode"
            :deptId="deptId"
            v-if="isEnableDialogCreate"
            @dialogClosed="isEnableDialogCreate = false"
            @closeDialog="closeDialog"
            @success="createDialogSuccess"/>

        </div>
      </div>
    </template>
  </listTemplate>
</template>
<script type="text/javascript">
    import moment from "moment";
    import listTemplate from "../../common/list";
    import searchTemplate from "../../common/search.vue";
    import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
    import FullCalendar from "@fullcalendar/vue";
    import headerTemplate from "../../../components/header/main-header.vue";
    import {EventBus} from "../../../event-bus.js";
    import utils from "../../../services/utils";
    import hanhchinhService from "../../../services/hanhchinhService";
    import mainContent from "./luongVb_MainContent.vue";
    import handleRequestErrorMixin from "../../handleRequestErrorMixin";
    import h from "../../../services/h";
    import { saveAs } from 'file-saver';

    export default {
        mixins: [handleRequestErrorMixin],
        components: {
            listTemplate,
            headerTemplate,
            searchTemplate,
            mainContent,
            VueCtkDateTimePicker,
            FullCalendar,
            filterByStatus: () => import('../components/filter-by-status-header.vue'),
            subHeader: () => import("../../../components/main/sub-header.vue"),
            registerLuongVbDialog: () => import("./luongVb_Form.vue"),
            advanceSearchDialog: () => import("./AdvanceSearch")
        },

        data() {
            return {
                hcFlow: null,
                flowCode: "LUONG_VB",
                flowId: null,
                deptId: null,
                isOpenDialogCreate: false,
                isEnableDialogCreate: true,
                isCreateSuccess: false,
                isOpenSendNotifyDlg: false,
                isEnableSendNotifyDlg: true,
                isSuccessSendNotify: false,
                searchKey: '',
                pageable: {
                    size: 20,
                    page: 0,
                    sort: 'createTime,desc'
                },
                isOpenAdvanceSearchDialog: false,
                isEnableAdvanceSearchDialog: false,
                hcCaseDocs: [],
                searchForm: {
                    orCondition: 1,
                    docOriginal: null,
                    docTypeId: null,
                    requestDeptId: null,
                    brief: null,
                    docNum: null,
                    docSign: null,
                    approverId: null,
                    state: null,
                    createTimeFrom: null,
                    createTimeTo: null
                }
            };
        },

        computed: {
            currentDeptId() {
                let userDeptRole = h.find(
                    this.$store.state.userDeptRoles,
                    userDeptRole => userDeptRole.id === this.$store.getters.userDeptRoleId
                );
                return userDeptRole.deptId;
            }
        },

        created() {
            this.getProcedureInformation();
            EventBus.$on("reloadPage", options => {
                this.reloadPage();
            });
        },

        destroyed() {
            EventBus.$off("reloadPage");
        },

        methods: {
            advanceSearch(data) {
                this.searchForm = {
                    orCondition: !data.andCondition ? 1 : 0,
                    docOriginal: data.docOriginal,
                    docTypeId: data.docTypeId,
                    requestDeptId: data.requestDeptId,
                    brief: data.keyword,
                    docNum: data.keyword,
                    docSign: data.keyword,
                    approverId: data.approverId,
                    state: data.state,
                    createTimeFrom: data.createTimeFrom,
                    createTimeTo: data.createTimeTo
                };
                this.reloadPage();
            },

            exportExcel(data) {
                this.searchForm = {
                    orCondition: !data.andCondition ? 1 : 0,
                    docOriginal: data.docOriginal,
                    docTypeId: data.docTypeId,
                    requestDeptId: data.requestDeptId,
                    brief: data.keyword,
                    docNum: data.keyword,
                    docSign: data.keyword,
                    approverId: data.approverId,
                    state: data.state,
                    createTimeFrom: data.createTimeFrom,
                    createTimeTo: data.createTimeTo
                };
                hanhchinhService.exportLuongVb(this.searchForm)
                    .then( reponse => {
                        let file = new Blob([reponse.data], { type: 'application/vnd.ms-excel' });
                        saveAs(file, 'luongvanban');
                    }).catch(error => this.commonHandleRequestError(error));
            },

            search(keyword) {
                this.searchForm = {
                    orCondition: 1,
                    docOriginal: null,
                    docTypeId: null,
                    requestDeptId: null,
                    brief: keyword,
                    docNum: keyword,
                    docSign: keyword,
                    approverId: null,
                    state: null,
                    createTimeFrom: null,
                    createTimeTo: null
                };
                this.reloadPage();
            },

            openAdvanceSearchDialog(keyword) {
                this.isOpenAdvanceSearchDialog = true;
                this.isEnableAdvanceSearchDialog = true;
            },

            closeDialog() {
                this.isOpenDialogCreate = false;
                this.isOpenSendNotifyDlg = false;
            },

            getProcedureInformation() {
                return hanhchinhService.getProcedureInformation(this.flowCode).then(response => {
                    if (response.data.hcFlow !== null) {
                        this.hcFlow = response.data.hcFlow;
                        this.flowId = this.hcFlow.id;
                        this.deptId = this.hcFlow.deptId;
                    }
                });
            },

            createDialogSuccess() {
                this.isOpenDialogCreate = false;
                this.isOpenSendNotifyDlg = false;
                this.isCreateSuccess = true;
                this.isSuccessSendNotify = true;
                this.reloadPage();
            },

            reloadPage() {
                this.hcCaseDocs = [];
                this.pageable.page = 0;
                if (this.$refs.mainContent1) {
                    this.$refs.mainContent1.$refs.infiniteLoading.stateChanger.reset();
                }
            },

            // xử lý thanh cuộn reloadPage
            infiniteHandler($state) {
                this.getListLuongVanBan(this.searchForm, this.pageable, $state);
            },

            getListLuongVanBan(form, pageable, $state) {
                return hanhchinhService.getListLuongVanBan(form, pageable).then(
                    response => {
                        let items = response.data.hcCaseDocs;
                        if (items.length > 0) {
                            items.forEach(item => {
                                item.hcCaseDoc.docDate = !item.hcCaseDoc.docDate ? '' : moment(item.hcCaseDoc.docDate).format("DD/MM/YYYY");
                                item.hcCaseDoc.timeDeadline = !item.hcCaseDoc.timeDeadline ? '' : moment(item.hcCaseDoc.timeDeadline).format("DD/MM/YYYY HH:mm");
                                item.hcCaseDoc.createTime = moment(item.hcCaseDoc.createTime).format("DD/MM/YYYY HH:mm");
                                item.hcCaseDoc.updateTime = moment(item.hcCaseDoc.updateTime).format("DD/MM/YYYY HH:mm");
                                item.hcCaseDoc.returnDate = item.hcCaseDoc.returnDate ? moment(item.hcCaseDoc.returnDate).format("DD/MM/YYYY HH:mm") : "";

                                let alreadyFinished = true;
                                for (let i = 0; i < item.hcCaseDocOrgs.length; i++) {
                                    let org = item.hcCaseDocOrgs[i];
                                    if (org.returnDeptId == this.currentDeptId && org.isNeedReport == 1 && org.sysStatus == 0) {
                                        alreadyFinished = false;
                                        break;
                                    }
                                }

                                let allFinished = true;
                                for (let i = 0; i < item.hcCaseDocOrgs.length; i++) {
                                    let org = item.hcCaseDocOrgs[i];
                                    if (org.isNeedReport == 1 && org.sysStatus == 0) {
                                        allFinished = false;
                                        break;
                                    }
                                }

                                item.alreadyFinished = alreadyFinished;
                                if (item.hcCaseDoc.state == 'Đã trả' && item.alreadyFinished && this.hcFlow != null) {
                                    item.hcCaseDoc.state = 'Hoàn thành';
                                } else if (item.hcCaseDoc.state == 'Đã trả' && allFinished && this.hcFlow == null) {
                                    item.hcCaseDoc.state = 'Hoàn thành';
                                }
                                if (this.searchForm.state == item.hcCaseDoc.state || this.searchForm.state == null) {
                                    this.hcCaseDocs.push(item);
                                }
                            });
                            this.pageable.page++;
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    }
                );
            },

            // xem chi tiet
            viewDetail(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});

                let routeName = "vbLuongVanBan-detail";
                if (this.hcFlow != null) {
                    routeName = "vbLuongVanBan-detailDv";
                }

                this.$router.push({
                    name: routeName,
                    params: params,
                    query: null
                });
            },

            viewDetailSteps(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});
                this.$router.push({
                    name: "vbLuongVanBan-detailSteps",
                    params: params,
                    query: null
                });
            },

            viewDetailHistory(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});
                this.$router.push({
                    name: "vbLuongVanBan-detailHistory",
                    params: params,
                    query: null
                });
            },

            viewDetailReturn(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});
                this.$router.push({
                    name: "vbLuongVanBan-detailReturn",
                    params: params,
                    query: null
                });
            },

            nhanVanBan(e) {
                let item = e.item;

                let form = {
                    caseMasterId: item.hcCaseDoc.caseMasterId
                };

                this.$confirm("Bạn có chắc muốn nhận văn bản này?", {
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy bỏ",
                    type: "warning"
                }).then(() => {
                    hanhchinhService.nhanVanBan(form).then(res => {
                        this.notifySuccess("Nhận văn bản thành công");
                        this.reloadPage();
                    }).catch(error => this.commonHandleRequestError(error));
                });
            },

            donViNhanVanBan(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});
                this.$router.push({
                    name: "vbLuongVanBan-detailReceive",
                    params: params,
                    query: null
                });
            },

            donViBaoCao(e) {
                let item = e.item;
                let params = utils.merge(this.$route.params, {id: item.hcCaseDoc.caseMasterId});
                this.$router.push({
                    name: "vbLuongVanBan-detailReport",
                    params: params,
                    query: null
                });
            },

            huyVanBan(e) {
                let item = e.item;

                let form = {
                    caseMasterId: item.hcCaseDoc.caseMasterId,
                    action: this.hcFlow != null ? "tuhuyvanban" : "huyvanban"
                };

                this.$confirm("Bạn có chắc muốn hủy văn bản này?", {
                    confirmButtonText: "Xác nhận",
                    cancelButtonText: "Hủy bỏ",
                    type: "warning"
                }).then(() => {
                    hanhchinhService.huyVanBan(form).then(res => {
                        this.notifySuccess("Hủy văn bản thành công");
                        this.reloadPage();
                    }).catch(error => this.commonHandleRequestError(error));
                });
            },

            notifyError(msg) {
                this.notify('Lỗi', msg, 'error', 2000);
            },

            notifySuccess(msg) {
                this.notify('Thông báo', msg, 'success', 2000);
            },
        }
    }
</script>
<style type="text/css">
  .grid-container {
    display: grid;
    overflow: hidden;
    width: 45%;
    float: left;
    grid-template-columns: auto;
    grid-gap: 10px;
  }

  .grid-container:last-child {
    width: 55%;
  }

  .grid-container > .item {
    font-size: var(--font-small);
    padding-right: 10px;
  }

  .grid-container:first-child > .item {
    padding-left: 10px;
  }

  .grid-container > .item > .title {
    font-weight: 500;
  }

  .fc-widget-header {
    background: var(--color-dark) !important;
  }

  .fc-widget-header > span {
    color: white;
  }

  .font_blued {
    color: var(--color-blue);
  }

</style>



// WEBPACK FOOTER //
// src/views/adminstration/luongvanban/luongVb_Index.vue